import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import AlbumAccordion from "./AlbumAccordion";
import Typography from "@material-ui/core/Typography";
import { Grid } from "@material-ui/core";
import { makeSpotifyAPIRequest } from "../api_utilities/spotify";
import {
  getTagsFromBackendAlbum,
  getTrackRatingFromBackendAlbum,
  makeBackendAPIRequest,
  backendBaseURL,
  linkTracks,
} from "../api_utilities/backend";
import CircularProgress from "@material-ui/core/CircularProgress";

const useStyles = (theme) => ({
  root: {
    padding: theme.spacing(2),
    height: "100%",
  },
  spaceBelow: {
    marginBottom: theme.spacing(2),
  },
});

class ToRateList extends React.Component {
  constructor(props) {
    super(props);

    this.state = { loading: true, albums: [] };
  }

  componentDidMount() {
    this.getAlbumsToRate();
  }

  getAlbumsToRate = () => {
    const url = new URL(backendBaseURL + "/album/get_albums_to_rate");

    makeBackendAPIRequest({
      url: url,
      method: "GET",
      onSuccessCallback: this.convertBackendAlbumsToSpotifyAlbums,
      onFailureCallback: () => {},
    });
  };

  convertBackendAlbumsToSpotifyAlbums = (backendResponse) => {
    const backendAlbums = backendResponse.albums;

    if (backendAlbums.length === 0) {
      this.setState({ loading: false });
      return;
    }

    const url = new URL("https://api.spotify.com/v1/albums");
    url.searchParams.append(
      "ids",
      backendAlbums.map((album) => album["id_spotify"]).join(",")
    );
    makeSpotifyAPIRequest({
      url: url,
      method: "GET",
      onSuccessCallback: (data) => {
        this.setState({
          loading: false,
          albums: data.albums.map((spotifyAlbum, i) => {
            const backendAlbum = backendAlbums[i];
            const firstAlbumInfo = backendAlbum.album_infos[0];
            const link_objects = [];

            const complete_album = {
              albumIndex: i,
              albumID: spotifyAlbum.id,
              albumName: spotifyAlbum.name,
              albumArtists: spotifyAlbum.artists
                .map((artist) => artist.name)
                .join(", "),
              albumTotalTracksRated: backendAlbum.songs.length,
              albumTotalTracks: spotifyAlbum.tracks.total,
              albumRating: backendAlbum.rating,
              averageScore: backendAlbum.average_score,
              albumArtURL: firstAlbumInfo.art_url,
              releaseYear: firstAlbumInfo.release_year,
              tracks: spotifyAlbum.tracks.items.map((track, i) => {
                const { rating, rating_links } = getTrackRatingFromBackendAlbum(
                  track,
                  backendAlbum
                );
                const { tags, tag_links } = getTagsFromBackendAlbum(
                  track,
                  backendAlbum
                );
                link_objects.push(...rating_links, ...tag_links);

                return {
                  index: i,
                  id: track.id,
                  name: track.name,
                  artistName: track.artists
                    .map((artist) => artist.name)
                    .join(", "),
                  trackNumber: track.track_number,
                  trackLength: track.duration_ms,
                  rating: rating,
                  tags: tags,
                };
              }),
            };

            linkTracks(link_objects);

            return complete_album;
          }),
        });
      },
      onNoContentCallback: () => {},
    });
  };

  onTrackRatedCallback = (albumID, albumIndex) => {
    const { albums } = this.state;

    const url = new URL(backendBaseURL + "/album/get_album");
    url.searchParams.append("id_spotify", albumID);

    makeBackendAPIRequest({
      url: url,
      method: "GET",
      onSuccessCallback: (backendAlbum) => {
        const album = albums[albumIndex];
        album.albumTotalTracksRated = backendAlbum.songs.length;
        album.albumRating = backendAlbum.rating;
        album.averageScore = backendAlbum.average_score;
        this.setState({ albums: albums });
      },
      onFailureCallback: () => {},
    });
  };

  onTrackRatedOptimistic = (albumIndex, trackIndex, newValue) => {
    const { albums } = this.state;
    albums[albumIndex].tracks[trackIndex].rating = newValue;
    this.setState({ albums: albums });
  };

  onTagsUpdatedOptimistic = (albumIndex, trackIndex, newValue) => {
    const { albums } = this.state;
    albums[albumIndex].tracks[trackIndex].tags = newValue;
    this.setState({ albums: albums });
  };

  render() {
    const { classes, store } = this.props;
    const { albums, loading } = this.state;

    return (
      <Card className={classes.root}>
        <Grid container spacing={3}>
          <Grid
            item
            container
            xs={12}
            justify={"flex-end"}
            className={classes.spaceBelow}
          >
            <Typography variant="overline">Albums to Rate</Typography>
          </Grid>
          {loading && albums.length === 0 ? (
            <Grid item container xs={12} justify={"center"}>
              <CircularProgress />
            </Grid>
          ) : (
            <div />
          )}
          {albums.map((album) => (
            <Grid item xs={12} key={album.albumID}>
              <AlbumAccordion
                trackAndAlbumInfo={album}
                onOpen={() => {}}
                onTrackRated={{
                  callback: this.onTrackRatedCallback,
                  optimistic: this.onTrackRatedOptimistic,
                }}
                onTagsUpdatedOptimistic={this.onTagsUpdatedOptimistic}
                hasLoadedTracks={true}
                store={store}
              />
            </Grid>
          ))}
        </Grid>
      </Card>
    );
  }
}

export default withStyles(useStyles)(ToRateList);
